import type { CSSProperties, ReactNode } from 'react';
import type { GameTheme } from '../types/game';

export function Theme({ theme, children }: { theme: GameTheme; children: ReactNode }) {
  const variables = {
    '--color-primary': theme.primary || '#b94364',
    '--color-secondary': theme.secondary || '#f2a65a',
    '--color-background': theme.background || '#fff7f0',
    '--color-surface': theme.surface || '#ffffff',
    '--color-text': theme.text || '#3f2932',
    '--font-family': theme.font || 'system-ui, sans-serif',
    '--radius': theme.borderRadius || '24px',
  } as CSSProperties;
  return <div className={`theme theme-${theme.style || 'default'}`} style={variables}>{children}</div>;
}

